import { Dayjs } from "dayjs"
import { BenefitYear } from "../enrollment/enrollment-types"
import { Disease } from "../opd/opd-types"
import { WorkOutPlace } from "../exercise/exercise-types"

export type EClaimListItem = {
  claimId: number
  claimName: string
  claimIcon: string
  maxClaimablePrice: number
  fixExchangeCoin: string
  availableAmount: number
  claimDetail: string
  claimTypeId: number
  sumClaimAmount: number
}

export type EClaimList = Array<EClaimListItem>

export type GetEClaimByIdProps = {
  claimId: number
}
export type GetEClaimHistoryByIdProps = {
  id: number
}

export type GetCurrentBenefitYear = {
  benefitYearId: number,
  startDate: number,
  endDate: number,
  isActive: boolean,
  active: boolean
}

export type RelativeGroup = {
  typeId: number
  typeName: string
  maxNumber: number
  description: string
  relativeList: RelativeList[]
}

export type RelativeList = {
  id: number
  title: string
  firstname: string
  lastname: string
  birthday: string
  nationalId: number
  userId: number
  relativeTypeId: number
  createdDate: number
  createdBy: string
  updatedDate: number
  updatedBy: string
  enable: boolean
  idCard?: string;
  educationId?: number;
  status?: string;
  statusUpdatedDate?: number;
  statusUpdatedBy?: string;
  reason?: string;
  remark?: string;
}
export type GetRelativeResponse = RelativeGroup[]

export type RelativeScg = {
  typeId: number
  typeName: string
  id: number
  title: string
  firstname: string
  lastname: string
}
export type RelativeScgResponse = RelativeScg[]

export type RelativeTypeResponse = {
  id: number
  name: string
  maxNumber: number
  description: string
  createdDate: number
  createdBy: string
  updatedDate: number
  updatedBy: string
  enable: boolean
}

export enum EClaimStatus {
  UNAPPROVED = 'UNAPPROVED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
}

export type EClaimsHistoryListResponse = EClaimHistory[]

export type EClaimHistory = {
  statusName: EClaimStatus;
  userClaimList: UserClaimList[];
}

export type UserClaimList = {
  id: number;
  userClaimNo: null | string;
  userId: number;
  claimId: number;
  exchangeCoin: number;
  claimName: string;
  claimDate: number;
  receiptFile: string;
  citizenFileUrl: string;
  userClaimStatus: null;
  remark: string;
  userClaimUpdatedBy: string;
  createdDate: number;
  createdBy: string;
  updatedDate: number;
  updatedBy: string;
  userClaimAmount: number;
  refundDate: number;
  userClaimUpdatedDate: number;
  userClaimAmountApprove: number;
  relativeId: number;
  slipDate: number;
  rejectedReason: string;
  userClaimDocumentList: UserClaimDocumentList[];
  claim: EClaimItem;
  relative: RelativeList;
  canceled: boolean;
  approved: boolean;
  userInfo: UserInfo;
}
// export type EClaimHistory = {
//   id: number
//   claimIcon?: string
//   userId: string
//   userName: string
//   claimId: number
//   exchangeCoin: number
//   claimName: string
//   claimDate: string
//   receiptFile: string
//   optionalFileUrl: string
//   accept: string
//   remark: string
//   acceptBy: string
//   empId: string
//   firstName: string
//   lastName: string
//   fullName: string
//   refundDate: string
//   allpayStatus: string
//   allpayUpdateDate: string
//   allpayRemark: string
//   allpayReason: string
// }
export type ClaimType = {
  id: number;
  nameTh: string;
  nameEn: string;
  descriptionTh: string;
  descriptionEn: string;
  icon: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
  enable: boolean | null;
  claims: any[];
};

export type EClaimItem = {
  id: number;
  itemCode: string;
  name: string;
  claimTypeId: number;
  exchangeCoin?: number;
  fixExchangeCoin?: number;
  detail?: string;
  show: boolean;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
  showDashboard?: boolean;
  allowedAmount: number;
  limit: number;
  limitType: number;
  probation: boolean;
  maxClaimableLimit: number;
  claimPrice?: number;
  icon: string;
  isTax: boolean;
  nameEn: string;
  description?: string;
  descriptionEn?: string;
  claimPercent?: number;
  useBudget: boolean;
  showDialog: boolean;
  showDialogMessage?: string;
  showDialogMessageEn?: string;
  showDescription?: string;
  showDescriptionTitle?: string;
  showSubClaim?: string;
  showSubClaimTitle?: string;
  showReceiptDate?: string;
  isDefaultValue?: boolean;
  defaultValue: any;
  toClaimId?: number;
  enable: boolean;
  isConsent: boolean;
  consentDescriptionTh?: string;
  consentDescriptionEn?: string;
  useCoin: boolean;
  claimDocumentTypes: ClaimDocumentTypes[];
  relativeTypes: RelativeType[];
  claimTypeName: string;
  isOPD: boolean;
  claimType: ClaimType;
  diseaseId?: number;
  workOutPlaceId?: number;
}
export type RelativeType = {
  id: number;
  code: string;
  name: string;
  maxNumber: number;
  description: null | string;
  createdDate: number;
  createdBy: string;
  updatedDate: number;
  updatedBy: string;
  enable: boolean;
  exchangeBenefit: boolean;
}
export type ClaimDocumentTypes = {
  id: number;
  claimId: number;
  userClaimId: number;
  documentTypeId: number;
  isRequired: boolean;
  documentType: DocumentType;
  filePath?: string
}
export type Files = {
  fileType: string;
  id: number;
  name: string;
}
export type DocumentType = {
  id: number;
  name: FileType;
  description: null | string;
  enable: boolean;
  files: Files[];
}
export type CreateEclaimUser = {
  claimId: number;
  receiptAmount: number;
  relativeId: number;
  receiptDate: string;
  consentDate: Dayjs | null;
  consentBy: number
  userClaimDocumentList: UserClaimDocumentList[];
  receiptNo: string;
  remark?: string;
}
export type UserClaimDocumentList = {
  documentTypeId: number;
  documentPath: string;
}
export type UploadFile = {
  id: number;
  name: string;
  fileType: string;
}[]
export enum FileType {
  ReceiptFile = 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
  OptionalFileUrl = 'ใบรับรองแพทย์',
  BirthCertificate = 'สำเนาใบเกิด หรือ สำเนาบัตรประชาชน บุตรบุญธรรม',
  OtherDocument = 'เอกสารอื่นๆ ที่เกี่ยวข้อง (ถ้ามี)'
}

export type EClaimFormParams = {
  id?: number
  name: string
  amountReceipt: number
  claimName: string
  claimDate: moment.Moment
  // userClaimDocumentList: UserClaimDocumentList[]
  receiptFile: string
  optionalFileUrl: string
  otherDocument: string
  birthCertificate: string
  relativeTypeId: string
  userRemark?: string
  allpayRef?: string
  relativeTitle?: string
  relativeFirstName?: string
  relativeLastName?: string
  receiptDate: string
  amountClaim: number
  nameShop: string
  slipNo: string
  receiptNo: string
  remark?: string
}

export type EClaimEnllomentItem = {
  totalSelectedCoin?: number
  preSelectedClaimWrapperList: PreSelectedClaimWrapperList[]
  claimTypeName: string
  claimTypeId: string | number
}

export type PreSelectedClaimWrapperList = {
  maxClaimablePrice: number
  fixExchangeCoin: boolean
  detail: string
  preSelectedAmount: number
  claimName: string
  claimId: number
}

export type EClaimEnllomentItemList = Array<EClaimEnllomentItem>

export type CreateUserClaimEnrollment = {
  claimTypeId: string
  benefitYearId: string
  usersPreSelectedClaimsDTOList: UsersPreSelectedClaimsDTOList[]
}

export type UsersPreSelectedClaimsDTOList = {
  preSelectedAmount: number
  claimId: string
}

export type CreateUserClaimEnrollments = Array<CreateUserClaimEnrollment>

export type EClaimListResponse = EClaimListGroup[]

export type EClaimListGroup = {
  id: number
  nameTh: string
  nameEn: string
  createdDate: number
  createdBy: string
  updatedDate: number
  updatedBy: string
  code: string
  icon: string
  descriptionTh: string
  descriptionEn: string
  claimList: EClaimItem[]
}

export type EClaimType = {
  id: number
  tax: boolean
  name: string
  limit: number
  icon: string
  nameEn: string
  limitType: number
  probation: boolean
  description: string
  claimTypeId: number
  showDialog: boolean
  allowedAmount: number
  claimTypeGroupId: number
  maxClaimableLimit: number
  showDialogMessage: string
  claimTypeGroupName: string
  createdBy: string
  updatedBy: string
}

export type EClaimListNew = {
  claimId: number
  claimName: string
  claimIcon: string
  maxClaimablePrice: number
  fixExchangeCoin: boolean
  availableAmount: number
  claimDetail: string
  claimTypeId: number
  sumClaimAmount: number
  claimTypeGroupId: number
  claimTypeName: string
  claimTypeGroupName: string
}

export type ClaimAmountCheckResponse = {
  claimableAmount: number
}

export type CreateEclaimUserResponse = {
  id: number;
  userClaimNo: string;
  userId: number;
  claimId: number;
  exchangeCoin: null;
  claimName: null;
  claimDate: null;
  receiptFile: null;
  citizenFileUrl: null;
  userClaimStatus: null;
  remark: null;
  userClaimUpdatedBy: null;
  createdDate: number;
  createdBy: string;
  updatedDate: number;
  updatedBy: string;
  userClaimAmount: number;
  refundDate: null;
  userClaimUpdatedDate: null;
  userClaimAmountApprove: number;
  relativeId: number;
  slipDate: number;
  rejectedReason: null;
  userClaimDocumentList: UserClaimDocumentList[];
  claim: null;
  relative: null;
  canceled: boolean;
  approved: null;
  userInfo: UserInfo;
}

export type EClaimHistoryItem = {
  id: number;
  userClaimNo: string;
  userId: number;
  claimId: number;
  benefitYearId: number;
  exchangeCoin?: number;
  claimName?: string;
  claimDate?: string;
  receiptFile?: string;
  citizenFileUrl?: string;
  userClaimStatus?: string;
  remark?: string;
  userClaimUpdatedBy?: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy: string;
  userClaimAmount: number;
  userClaimUpdatedDate?: string;
  userClaimAmountApprove: number;
  relativeId?: number;
  slipDate: string;
  isApproved?: boolean;
  isCanceled?: boolean;
  rejectedReason?: string;
  status: string;
  paymentDate?: string;
  fullName: string;
  userLocation: string;
  consentBy: string;
  consentDate: string;
  claim: EClaimItem;
  relative: RelativeList;
  user: UserInfo;
  benefitYear: BenefitYear;
  documentTypes: DocumentType[];
  receiptNo: string;
  disease?: Disease;
  workOutPlace?: WorkOutPlace;
}

export type UserInfo = {
  userId: number;
  empId: string;
  firstname: null;
  lastname: null;
  firstnameEn: string;
  lastnameEn: string;
  phoneNumber: null;
  email: string;
}